export function createParticipantSelectorRequestGuard() {
  let sequence = 0

  return {
    next() {
      sequence += 1
      return sequence
    },
    isCurrent(value) {
      return value === sequence
    },
    current() {
      return sequence
    },
  }
}
